import Link from "@rentspree/component-v2/dist/button/link"
import { COLOR } from "styles/settings"
import styled from "styled-components"

// this because there was "body a {text-decoration: none !important}" from styledComponent
export const StyledLink = styled(Link)`
  text-decoration: underline !important;
`

export const LoadingSpin = styled.img`
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  @keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`

export const CardElementContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
export const CardElementInputBox = styled.div`
  background: ${props => props.background || COLOR.white};
  padding: 9px 15px;
  border: 1px solid ${props => props.border};
  margin: 0;
  @media (max-width: 991px) {
    margin: 0 0 10px 0;
    :last-child {
      margin: 0;
    }
  }
`
export const Logo = styled.img`
  width: 140px;
  height: 30px;
`

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 24px;
`

export const SavedCardInformation = styled.div`
  display: flex;
  align-items: center;
`

export const StyledCardInformationImage = styled.img`
  width: ${props => props.width};
  height: ${props => props.height};
  margin-right: ${props => props.marginRight || "15px"};
`
export const DetailRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  width: 100%;
`

export const BillingDateRow = styled(DetailRow)`
  margin: 0 0 10px 0;
`

export const RemoveCoupon = styled.button`
  padding: 0;
  width: fit-content;
  white-space: nowrap;
  font-size: 14px;
  align-self: flex-end;
  text-decoration: underline;
  font-weight: 600;
`

export const NumberWrapper = styled.div`
  display: flex;
  align-items: baseline;
`

export const SplitLineCondition = styled.div`
  display: inline;
  @media (max-width: 991px) {
    display: block;
  }
`

export const SplitLineTrialCondition = styled.div`
  display: block;
  @media (max-width: 991px) {
    display: inline;
  }
`
